import actionTypes from 'SRC/modules/redux/actionTypes'

export const setError = error => ({
  type: actionTypes.SET_VEHICLE_PARTS_ERROR,
  payload: error
})
